import { UiStrings } from "./UiStrings";

export const UiStringsEs: UiStrings = {
  common: {
    dismiss: 'Descartar',
    close: 'Cerrar',
    continue: 'Continuar',
    back: 'Volver',
    xp: 'XP',
    explain: 'Explicar',
    and: 'y',
    or: 'o',
    secShort: 's',
    minShort: 'min',
    saveChanges: 'Guardar cambios',
    logout: 'Cerrar sesión',
    ago: 'hace',
    yes: "Sí",
    no: "No",
    translate: "Traducir",
    saveTerm: 'Guardar vocabulario',
    tryAgain: "Intentar otra vez",
    pleaseWait: "Por favor, espera...",
    checkAgainLater: "Revisa de nuevo más tarde",
    errors: {
      tooManyRequests: "Has usado esto demasiadas veces, por favor, inténtalo de nuevo más tarde.",
    }
  },
  nav: {
    header: {
      tabs: {
        workbook: 'Libro de trabajo',
        contacts: 'Contactos',
        feed: 'Para ti',
        recent: 'Reciente',
        games: 'Juegos',
      }
    },
    bottomBar: {
      home: 'Inicio',
      contacts: 'Contactos',
      feed: 'Feed',
      inbox: 'Tareas',
      vocab: 'Vocab',
    }
  },
  tryit: {
    existingUsersLogin: 'Para usuarios existentes',
  },
  login: {
    title: 'Iniciar sesión',
    welcome: 'Bienvenido a la app',
    requestCodeButton: 'Solicitar código de inicio:',
    requestCodeInfo: 'Usa Telegram o email para solicitar un código de inicio que debes ingresar aquí.',
    codeInputLabel: 'Código de autenticación',
    verifyCodeButton: 'Verificar código',
    verifying: 'Verificando...',
    codeInputPlaceholder: 'El código de Telegram',
    codeEmailInputPlaceholder: 'El código de email',
    codeInputError: 'Código inválido',
    codeInputSuccess: 'Código verificado correctamente',
    cancel: 'Cancelar',
    emailInputLabel: 'Correo electrónico',
    emailInputPlaceholder: 'Ingresa tu correo electrónico',
    sendCodeButton: 'Enviar código',
    sendingCode: 'Enviando...',
    checkEmail: 'Revisa tu correo electrónico para el código de autenticación',
    codeExpiresIn: 'El código expira en',
    resendCode: 'Reenviar código',
    selectNativeLanguage: 'Selecciona tu idioma nativo',
  },
  landing: {
    demoChat: {
      tagline: 'Práctica de hablar con IA 🎤👂💥',
      correction: 'Corrección',
      responseOptions: 'Opciones de respuesta',
    },
    testimonials: {
      title: 'Lo que dicen nuestros usuarios',
    },
    learningMotivation: {
      title: 'Útil en diferentes situaciones',
    },
    voiceExamples: {
      title: "Conversaciones AI como reales",
      detail: "Practica con nuestros tutores de IA usando voces naturales y humanas para sumergirte en cualquier idioma.",
      listen: "Escuchar",
      pause: "Pausa",
      playing: "Reproduciendo...",
      info: {
        title: "Aprende fluidez con tutores de IA que suenan humanos",
        chip1: "Temas flexibles",
        chip2: "Herramientas de aprendizaje",
        chip3: "Retroalimentación detallada",
        chip4: "Voces realistas",
      },
      leadOut: "Nuestros tutores de IA usan modelos de voz premium que suenan naturales y te responden en tiempo real."
    },
    betterWithTelegram: {
      title: "Mejor con Telegram",
      info: "Nuestro bot de IA está integrado con Telegram y puede responder inteligentemente a tus mensajes y ayudar con seguimientos de práctica y exámenes.",
      info2: "El bot de Telegram de Chatlanga será tu compañero de práctica confiable para tus habilidades de gramática y expresión.",
    },
    videoCarousel: {
      practiceStart: "Elige entre una variedad de temas y juegos y usa tus ideas 💡",
      fluencyMeter: "Medidor de fluidez en tiempo real rastrea tu progreso ⏱️",
      tapTranslations: "¿Palabras desconocidas? Traduce cualquier mensaje tocándolo 🌐",
      responseOptions: "Práctica sin estrés con sugerencias de respuesta de IA 😌",
    },
    knowledgeBase: {
      title: 'Recursos de aprendizaje',
      info: 'Para algunos idiomas, Chatlanga ofrece recursos de aprendizaje personalizados para hablantes nativos de diferentes culturas.',
      info2: 'Nuestra base de contenido crece constantemente y es una colección de artículos, cuestionarios y ejercicios de comprensión auditiva en diferentes temas y aspectos gramaticales del idioma.',
    }
  },
  dashboard: {
    progress: {
      title: 'Progreso',
      description: 'Rastrea tu progreso en tu idioma',
      currentRank: 'Rango actual',
      nextRank: 'Siguiente rango',
      practicesTaken: 'Prácticas tomadas',
      examsTaken: 'Exámenes tomados',
      wordsLearned: 'Palabras aprendidas',
      vocabSize: 'Tamaño del vocabulario',      
    },
    practice: {
      title: 'Llamada de voz',
      description: 'Práctica tu idioma con nuestras sesiones de práctica',
    },
    chatPractice: {
      title: 'Chat de voz',
      description: 'Práctica tu idioma con nuestras sesiones de práctica de chat',
    },
    exam: {
      title: 'Examen',
      description: 'Toma tu examen de idioma con nuestra simulación de examen',
      notAvailable: 'No disponible todavía, llegará en unos pocas semanas...',
    },
    corrections: {
      title: 'Errores recientes',
      description: 'Ver tus errores recientes',
      noMistakes: 'Errores eliminados! Sigue así!',
      noSessions: 'Intenta tu primera sesión de práctica para mejorar tus habilidades de idioma!',
      dismissing: 'Descartando corrección...',
      originalPhrase: 'Frase original',
      correction: 'Corrección',
      comment: 'Comentario',
      showMore: 'Mostrar todos',
      showLess: 'Mostrar menos',
    },
    vocabulary: {
      title: 'Nuevo vocabulario',
      description: 'Ver tu nuevo vocabulario',
      buttonLearn: 'Aprendido',
      buttonDismiss: 'Descartar',
      originalPhrase: 'Frase original',
      updating: 'Actualizando vocabulario...',
    },
    recentConversations: {
      title: 'Conversaciones recientes',      
      noSessions: 'No hay conversaciones todavía. Intenta una sesión de práctica!',            
    },
    chatExercises: {
      title: 'Ejercicios en chat',
      info: 'Obtén un ejercicio aleatorio de nuestro tutor de IA en tu Telegram',
      send: 'Enviar',
      more: 'Más',
    },
    articles: {
      title: 'Artículos para ti',
    },
    rewards: {
      title: 'Premios',
      noRewards: 'No hay premios todavía',
    },
  },
  creditsInfo: {
    credits: 'créditos',    
    one_credit: 'crédito',
    many_credits: 'créditos',
    inflectCredits: function(count: number, form: 'nominative' | 'genitive' | 'dative' | 'accusative' | 'instrumental' | 'prepositional') {
      if (count === 1) {
        return `${this.one_credit}`;
      }
      return `${this.many_credits}`;
    },
    buyMoreCredits: 'Comprar más',
  },
  languages: {
    title: 'Ajustes de idioma',
    backToDashboard: 'Volver al panel de control',
    appLanguage: 'Idioma de la app',
    selectLanguageLabel: 'Selecciona el idioma que quieres aprender:',
    messages: {
      levelNotAvailable: 'Nivel no disponible',
      levelNotAvailableDescription: '⏳  Pronto disponible en unos pocos días! El tutor para este nivel no está disponible todavía.',
    }
  },
  examDetails: {
    spanish: {
      oral: {
        beginner: {
          instructions: 'Te darán un tema de monólogo y un tema de diálogo. Tendrás 10 minutos para preparar tu monólogo y diálogo. Después, se te mostrará una imagen que deberás describir.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    },
    german: {
      oral: {
        beginner: {
          instructions: 'Te darán un tema de monólogo y un tema de diálogo. Tendrás 10 minutos para preparar tu monólogo y diálogo. Después, se te mostrará una imagen que deberás describir.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    }
  },
  exam: {
    stages: {
      monologue: 'Monologue',
      dialogue: 'Dialogue',
      describing: 'Image Describing',
    },
    scoreComponents: {
      hollistic: 'Hollistic',
      corrections: 'Grammar',
      fluency: 'Fluency',
      reach: 'Reach',
      coherence: 'Coherence',
    },
    completed: {
      sendSummary: 'Send Summary',
      overall: {
        title: 'Overall',
      },
      stageScores: {
        title: 'Scores by Stage',
        max: 'Max',
        mean: 'Mean',
      },
      skills: {
        title: 'Skills Assessment',
        detail: 'Scale: 1-10',
      },
      observations: {
        title: 'Observations',
        emptyCategory: 'No observations in this category',
      },
      corrections: {
        title: 'Corrections',
        emptyList: 'No corrections detected',
      }
    }
  },
  beforeConversation: {
    silencePlease: "Busca un entorno tranquilo",
    silenceInfo: "Asegúrate de estar en un cuarto tranquilo y que nadie esté hablando cerca de ti",
  },
  beforeExam: {
    title: 'Simulación de examen',
    approximateSimulation: 'Simulación aproximada',
    examDurationMinutes: 'min',
    tutorLabel: 'El examen es conducido por:',
    yourTicket: 'Tus temas de examen:',
    welcome: function(firstName: string) {
      return `Bienvenido, ${firstName}!`;
    },
    audioPermissions: {
      title: 'Permisos de audio',
      ensurePermissions: 'Prepara tu micrófono y auriculares o altavoces:',      
    },
    examStages: {
      monologue: 'Monólogo',
      dialogue: 'Diálogo',      
    },
    startExam: "Comenzar examen",
    startFirstStage: "Comenzar",
  },
  beforePractice: {
    title: 'Hora de practicar!',
    tutorShortIntro: 'Tu tutor de práctica:',
    connectingWith: 'Conectando con',
    welcome: function(firstName: string) {
      return `Bienvenido, ${firstName}!`;
    },
    notEnoughCredits: 'Añade créditos',
    muteNotice: 'Por favor, asegúrate de que 🔇 => 🔊 tu pestaña del navegador no esté desmutada.',
    audioPermissions: {
      title: 'Permisos de audio',
      ensurePermissions: 'Prepara tu micrófono y auriculares o altavoces:',      
    },
    configurePractice: "Prepara práctica",
    startPractice: "Comenzar",
    settings: {
      title: 'Configuración de práctica',
      motherLanguage: 'Tu idioma nativo',
      targetLanguage: 'Idioma a practicar',
      languageLevel: 'Tu nivel',
      continue: 'Continuar a practicar',
      edit: 'Cambiar',
    },
    userGoals: {
      default: 'Fluencia',
      exam: 'Preparación de examen',
      travelTo: 'Viajar/mudarse',
      jobInterview: 'Trabajo/promoción',
      relationship: 'Idioma de pareja',
      rentApartment: 'Alquilar un apartamento',
      talkToAccountant: 'Dinero y impuestos',
      talkToDoctor: 'En el doctor\'s',
      escapeRoom: 'Escape room',
      treasureHunt: 'Buscatesoros',
      grammarExercises: 'Gramática',
      wordGame: 'Juego de palabras',
      practiceIntro: 'Tutorial',
      custom: 'Escribe tu propio...',
    }
  },
  userGoalsDialog: {
    title: '¿Cuál es tu objetivo de práctica?',
    subtitle: 'Elige un objetivo de práctica para personalizar tu conversación con el tutor',
    customGoal: 'Tu objetivo personalizado',
    customGoalPlaceholder: 'e.g. "Habla con tus compañeros de escuadrón en Fortnite"',
  },
  audioPermissions: {
    enableMicrophone: 'Habilitar micrófono y desmutear',
    clickToFix: 'Haz click para arreglar',
    microphone: 'Micrófono',
    microphoneNotEnabled: 'El micrófono no está habilitado, haz click en el botón para habilitarlo:',
  },
  audioDeviceSelector: {
    microphone: 'Micrófono',
    speakers: 'Auriculares o altavoces:',
    muteNote: '* También puedes desmutear la pestaña del navegador',
  },
  topicSelection: {
    title: 'Selecciona un tema',
    instructions: "Haz click en el botón para seleccionar un tema aleatorio.\n Tendrás 10 minutos para preparar tu presentación.",
    button: 'Dibujar tema',
    info1: "La simulación de examen consta de dos partes: 1) tu introducción y monólogo sobre un tema dado, y 2) una conversación con el examinador, donde te harán preguntas dentro de un contexto imaginario.",
    info2: "Tendrás 10 minutos para preparar tu presentación, después de lo cual comenzará la conversación. Puedes saltar la espera y comenzar la conversación antes, si quieres.",
    skipWait: 'Comenzar',
    anotherTopic: 'Otro tema',
    topicDescription: 'Descripción',
    topicInstructions: 'Instrucciones',
  },
  examFlow: {
    describeImage: {
      defaultInstruction: "Describe la situación representada en esta imagen",
    }
  },
  rating: {
    title: '¡Gracias por tu presentación!',
    nextUp: 'Siguiente:',
    conversation: 'Evaluación de habilidades de conversación',
    continue: 'Continuar',
  },
  conversationInterface: {
    start: 'Comenzar',
    abort: 'Terminar',
    continue: 'Continuar',
    pleaseWait: 'Por favor, espera...',
    stageNames: {
      intro: 'Introducción',
      monologue: 'Monólogo',
      dialogue: 'Diálogo',
      practice: 'Práctica',
    },
    conversationState: {
      ready: 'Listo para comenzar',
      inProgress: 'Conversación en progreso',
      clickToEnd: 'Haz click en el botón para terminar la conversación',
      clickToStart: 'Haz click en el botón para comenzar a hablar',
    },
    countdown: {
      timeLeft: 'Tiempo restante:',
      timeUp: 'Tu tiempo casi se ha acabado, termina y despedite!',
      timeLeftToPrepare: 'Tiempo restante para preparar:',
    }
  },
  practiceSessionBoard: {
    title: 'Notas del tutor',
    transcriptionTitle: 'Texto de la conversación',
    yourTurnToSpeak: 'Tu turno para hablar',
    mistakesDetected: 'Errores detectados',
    vocab: {
      title: 'Nuevo vocabulario',
      dismissKnown: 'Ignorar',
      willBeSent: 'Esto se te enviará después de la sesión',
      emptyList: 'No hay nuevo vocabulario hasta ahora',
    },
    corrections: {
      title: 'Correcciones',
      dismiss: 'Ignorar',
      willBeSent: 'Esto se te enviará después de la sesión',
      emptyList: 'No hay correcciones hasta ahora',
    },
    history: {
      title: 'Historial de conversaciones',
      emptyList: 'Nada dicho todavía',
      you: 'Tú',
      tutor: 'Tutor',
    },
  },
  footer: {
    support: 'Soporte',
    checkWebsite: 'Revisa nuestro sitio web',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos de servicio',
    acceptTerms: 'Acepto los términos de servicio y la política de privacidad',
  },
  profile: {
    referral: {
      title: 'Invita a tus amigos y recibe créditos',
      description: 'Comparte tu enlace de invitación con tus amigos. Cuando ellos se registran, ambos recibirán créditos adicionales!',
      copied: '¡Copiado!',
      copy: 'Copiar',
      invitedCount: function(count: number) {
        return `¡Has invitado a ${count} amigos hasta ahora!`;
      },
    },
    personal: {
      title: 'Tus datos personales',
      firstName: 'Nombre',
      lastName: 'Apellido',
      telegramUsername: 'Nombre de usuario de Telegram',
      notConnected: 'No conectado',
      telegramLinked: 'Conectado a tu cuenta de Telegram',
    },
    notifications: {
      title: 'Notificaciones',
      practiceReminders: 'Recordatorios de práctica via Telegram',
      practiceRemindersDescription: 'Recibe recordatorios para practicar a través de nuestro bot de Telegram',
      reminderFrequency: 'Frecuencia de recordatorios',
      frequentDaily: 'Frecuente (Diario)',
      moderateWeekly: 'Moderado (2-3 veces por semana)',
      rareWeekly: 'Raro (Semanal)',
    },
    chatResponses: 'Respuestas de chat AI disponibles hoy',
    deleteAccount: {
      deleteButton: 'Eliminar cuenta',
      deleteButtonInfo: 'Esto eliminará tu cuenta y todos tus datos. Los datos restantes pueden tardar hasta 6 días naturales en estar completamente eliminados.',
      deleteConfirmation: 'CONFIRMAR: ¿Estás seguro de que quieres eliminar tu cuenta? ¡Esta acción no puede ser deshecha!',
    },
    tutorials: {
      resetButton: 'Restablecer consejos de tutorial',
      resetButtonInfo: 'Esto restablecerá todos tus consejos vistos (mensajes de tutorial en la parte inferior de la pantalla) y hará que aparezcan al menos una vez.',
      notifications: {
        tutorialsReset: 'Los consejos de tutorial han sido restablecidos',
      }
    }
  },
  assessmentLoading: {
    title: 'Evaluación en progreso',
    subtitle: 'Por favor, espera mientras procesamos tus resultados...',
    stateComplete: 'Completo',
    step1Label: 'Recopilando transcripción',
    step2Label: 'Analizando gramática',
    step3Label: 'Puntuando vocabulario',
    step4Label: 'Clasificando fluidez',
    step5Label: 'Generando correcciones',
    step6Label: 'Creando recomendaciones',
  },
  assessmentDetails: {
    title: 'Detalles de la evaluación',
    practice: 'Práctica',
    monologue: 'Monólogo',
    dialogue: 'Diálogo',
    grammar: 'Gramática',
    vocabulary: 'Vocabulario',
    fluency: 'Fluidez',
    fluencyChart: 'Fluidez en la conversación',
    pronunciation: 'Pronunciación',
    overall: 'Overall',
    corrections: 'Correcciones',
  },
  practiceCompleted: {
    tryAgainButton: 'Intentar de nuevo',
    sendSummaryButton: 'Enviar resumen',
    firstTryIssues: {
      info1: "Nos damos cuenta, que has tenido algunos problemas. No pasa nada! Si no sabes cómo decir algo, puedes hablar en tu idioma nativo.",
      info2: "Toca los mensajes para traducirlos a tu idioma nativo.",
      info3: "No te preocupes! Te ofrecemos un reintento gratis, solo comienza una nueva sesión de práctica ahora:",
      retryButton: "Reintentar gratis ahora",
    },
    creditsLeft: (credits: number) => `Tienes ${credits} ${UiStringsEs.creditsInfo.inflectCredits(credits, 'genitive')} restantes`,
    tryGameModes: "Prueba nuestros desafiantes modos de juego:",
    tryWithCreditsInfo: (credits: number, sessionsLeft: number, price: number) => `Con ${credits} créditos puedes probar ${sessionsLeft} más veces! Al final de cada sesión se te cobrará ${price} créditos.`,
  },  
  converationAudioIssues: {
    title: "Sonido no detectado",
    noSpeechDetected: "No se detectó habla durante tu sesión de práctica. Esto podría deberse a problemas técnicos con tu configuración de micrófono.",
    pleaseCheck: "Por favor, revisa lo siguiente:",
    ensureSilentModeOff: "Asegúrate de que el modo silencioso de tu dispositivo esté <b>apagado</b> y el volumen esté encendido",
    ensureMicrophoneEnabled: "Revisa que tu <b>micrófono esté habilitado</b> en las configuraciones de tu navegador",    
    checkHeadset: "Revisa que estés usando <b>un auricular o altavoces externos</b> pero no ambos",
    ensureTabNotMuted: "Asegúrate de que tu pestaña del navegador no esté <b>mutuda</b>",
  },
  onboarding: {
    title: "Información personal",
    welcome: "Personaliza tu experiencia de aprendizaje",
    continue: "Continuar",
    welcomeSubtitle: "Comienza tu viaje de fluidez",
    welcomeInfo: "Completa el formulario para comenzar. Cada sección se desbloqueará a medida que completes la anterior.",
    personalInfo: {
      title: "Información personal",
      firstName: "Nombre",
      firstNameInfo: "Los tutores usarán este nombre para dirigirse a ti",
      firstNamePlaceholder: "Tu nombre",
      lastName: "Apellido",
      lastNamePlaceholder: "Tu apellido",
    },
    languageInfo: {
      title: "Learning Preferences",
      subtitle: "",
      motherLanguage: "Tu idioma nativo",
      motherLanguageInfo: "Esto se usará para las instrucciones y la interfaz de usuario",
      targetLanguage: "Idioma que estás aprendiendo",
      languageLevel: "Tu nivel actual",
    },
    learningMotivation: {
      title: "Motivación para aprender",
      subtitle: "¿Por qué decidiste aprender este idioma?",
      options: {
        relocation: "Reubicación",
        exam: "Examen",
        travel: "Viajar",
        relationship: "Relación",
        career: "Carrera",
        family: "Familia",
        other: "Algo más!",
      },
    },
    learningGoals: {
      title: "Objetivos de aprendizaje",
      subtitle: "¿Cuáles son tus objetivos de aprendizaje?",
      options: {
        fluency: "Mejorar fluidez",
        vocab: "Aprender más palabras",
        idioms: "Idiomas nativos",
        anxiety: "Superar el estrés",
        job: "Obtener un trabajo",
        other: "Algo más!",
      },
    },
    learningSchedule: {
      title: "Regularidad de la práctica",
      subtitle: "<b>Pro tip:</b> Nuestro app funciona mejor cuando practicas un poco (incluso solo 5 minutos) casi todos los días, en lugar de largas sesiones menos frecuentemente.",
      question: "¿Cuántas veces planeas practicar?",
      options: {
        few_times_per_day: "A algunas veces al día",
        once_per_day: "Una vez al día",
        few_times_per_few_days: "A algunas veces por semana",
        idk: "No sé",
        other: "Algo más!",
      }
    },
    termsOfService: {
      title: "Aviso legal",
      termsOfService: "Términos de servicio",
      privacyPolicy: "Política de privacidad",
      acceptTerms: "Acepto los términos de servicio y la política de privacidad",
      confirmAge: 'Tengo al menos 16 años',
      confirmAgeInfo: 'Algunos países requieren que las conversaciones de IA estén restringidas a usuarios de al menos 16 años.',
    },
    completeSetup: "Comenzar a aprender",
  },
  examStatus: {
    title: '¡Gracias por completar la simulación de examen!',
    postExamInfo: "Tu sesión de examen de idioma ha sido completada exitosamente. \nEsperamos que esta experiencia te haya sido útil para mejorar tus habilidades de habla.",
    quickAssessment: {
      pleaseWait: 'Por favor, espera mientras procesamos tus resultados...',
      title: 'Evaluación rápida',
      monologue: 'Evaluación de monólogo',
      dialogue: 'Evaluación de diálogo',
      grammar: 'Gramática',
      vocabulary: 'Vocabulario',
      fluency: 'Fluidez',
      totalScore: 'Puntuación total',
      feedback: 'Feedback:',
    },
    recordings: {
      title: 'Tus grabaciones',
      monologue: 'Grabación de monólogo',
      dialogue: 'Grabación de diálogo',
      pleaseWait: 'La grabación está siendo creada...',
    },
    thankYou: {
      title: '¡Gracias por completar nuestra simulación de examen!',
      reloadLater: "Puedes cambiar a otra pestaña pero no cierra esta. Carga la página más tarde para obtener la evaluación completa del tutor.",
    }
  },  
  practiceResponseOptions: {
    title: 'Sugerencias de respuesta',
    disabledTitle: 'Sugerencias',
    dismiss: 'Descartar',
    loading: 'Cargando...',
    noOptions: 'No se encontraron opciones',
    tutorSaid: 'El tutor dijo:',
    enable: 'On',
    disable: 'Off',
  },
  balance: {
    buyMoreCredits: 'Comprar más',
    startCheckout: 'Ir a pago',
    thanks: '¡Gracias por tu compra!',
    purchaseSuccessful: 'Compra exitosa',
    aboutCredits: {
      title: '¿Cómo usar créditos?',
      details: 'Los créditos se usan para comprar servicios basados en IA en la app de Chatlanga. Nuestros modelos de alta calidad y generación de voz premium requieren una gran potencia de GPU 💪 y trabajamos duro para mantenerlos funcionando suavemente.',
      services: {
        practice: {
          title: 'Práctica de habla',
          detail: 'Sesión de práctica de 5 minutos con un tutor de voz de IA premium',
        },
        exam: {
          title: 'Sesión de examen',
          detail: 'Simulación de examen con tres partes: presentación, diálogo y descripción',
        },
        chatPackStandard: {
          title: 'Paquete de respuesta básico',
          detail: '50 respuestas inteligentes de nuestro tutor de IA en Telegram',
        },
        chatPackPremium: {
          title: 'Paquete de respuesta premium',
          detail: '200 respuestas inteligentes de nuestro tutor de IA en Telegram',
        }
      }
    }
  },
  coupons: {
    couponForm: {
      title: 'Activación de cupón',
      codeLabel: 'Tu código de cupón',
      codePlaceholder: 'Código del cupón...',
      submitButton: 'Aplicar',
    },
    modal: {
      title: 'Cupón activado!',
      detail: 'Tu cupón ha sido aplicado exitosamente.',
      defaultMessage: 'Se han añadido créditos a tu cuenta.',
    },
    errors: {
      notFound: 'Coupon not found',
      alreadyClaimed: 'Coupon already claimed',
      failedToClaim: 'No se pudo aplicar el cupón',            
    }
  },
  support: {    
    tabs: {
      articles: 'Ayuda',
      myTickets: 'Mis tickets',
    },
    articles: {
      title: 'Preguntas comunes',
      botChatInfo: 'No seas tímido y pregunta a nuestro bot de Telegram Chatlanga para ayuda! Puede proporcionar soporte básico y escalar su caso si es necesario.',
      telegramSupport: 'Pregúntanos en Telegram',
    },
    ticketForm: {
      title: 'Enviar solicitud',
      email: 'Email',
      emailPlaceholder: 'Tu email...',
      topic: 'Tema',
      topicPlaceholder: 'Problema o sugerencia...',
      type: 'Tipo de solicitud',
      typePlaceholder: 'Selecciona el tipo de solicitud',
      requestType: {
        bug: 'Reporte de error',
        suggestion: 'Sugerencia',
        featureRequest: 'Solicitud de característica',
        other: 'Otro',
      },
      message: 'Mensaje',
      messagePlaceholder: 'Describe tu problema o sugerencia...',
      submitButton: 'Enviar',
      submitted: 'Solicitud enviada exitosamente!',
    },
    myTickets: {
      title: 'Mis tickets',
      createTicket: 'Crear ticket',
      noTickets: 'Si quieres obtener ayuda, haz click en el botón de abajo para crear una nueva solicitud de soporte:',
      createTicketButton: 'Crear ticket',
      ticketList: {
        open: 'Abierto',
        inProgress: 'En progreso',
        closed: 'Cerrado',
      },
    }
  },
  pushToTalk: {
    defaultLabel: 'Presiona y habla',
    recording: 'Suelta para enviar',
    processing: 'Espera...',
    speakNow: 'Grabando...',
  },
  soundTest: {
    title: "Prueba de audio",
    instructionPrefix: "Dile:",
    testPhrase: "Estoy listo para empezar",
    confirmationQuery: "¿Oíste la respuesta?",
    successMessage: "Prueba de audio completada exitosamente!",
    micError: "Asegúrate de que tienes permisos para usar el micrófono y revisa si tienes algún dispositivo Bluetooth adicional conectado",
    tabMutedError: "🔇 => 🔊 Revisa si tu pestaña está silenciada!",
  },
  chatSpeechMeter: {
    info: function(wpm: number, minWpm: number, maxWpm: number, levelName: string) {
      return `Hablas a ≈${wpm} palabras por minuto. Para nivel ${levelName} el rango apto es de ${minWpm} - ${maxWpm} palabras por minuto.`;
    }
  },
  voiceChat: {
    chatFlow: {
      title: "Chat de voz",
      playbackRate: "Tasa de reproducción de voz",
      messagePlaceholder: "Escribe tu mensaje...",
      hints: {
        pushToTalk: "Mantén presionado o presiona para hablar, presiona de nuevo o suelta para enviar",
        emotions: "Selecciona un emoción para expresar cómo te sientes!",
      },
      history: {
        assist: "Pistas",
        notes: "Notas",
      },
      limitNoice: {
        title: "Límite diario alcanzado",
        detail: "⏳ Has alcanzado el límite diario para enviar mensajes. Por favor, espera hasta la medianoche para que los límites se actualicen.",
      }
    },
    inventory: {
      manager: {
        title: "Inventario del chat",
      },
      itemDetails: {
        acquiredInMessage: "Adquirido en contexto:",
        emptyList: "Los objetos que pueden ser usados en el chat o que recibes durante el chat aparecerán aquí.",
        itemReceived: "Objeto recibido",
        itemLost: "Objeto dado",
      },
    },
    panels: {
      wordCounter: {
        title: "Palabras",
      },
      progress: {
        title: "Progreso",
      },
      lives: {
        title: "Vidas",
      },
    }
  },
  todoLists: {
    dashboardTitle: "Tus Tareas",
    currentTask: "Tarea:",
    item: {
      status: {
        completed: "Completado",
      }
    },
    drawer: {
      defaultLabel: "Tarea académica",
      loading: "Por favor, espera mientras el tutor prepara las notas de la tarea...",
    },
    modals: {
      taskCompleted: {
        title: "Tarea completada",
        continueLearning: "Continuar aprendiendo",
      },
      taskCreated: {
        title: "Nueva tarea",
      },
      rewardReceived: {
        title: "¡Nuevo premio!",
      },
    }
  },
  imageOverlay: {
    zoomTip: "Toca para zoom • Pinch para zoom • Arrastra para mover",
  },
  feed: {
    miniChallengeButton: "Mini-Challenge",
    loader: {
      title: "Cargando nuevos posts",
      subtitle: "Preparando contenido personalizado para ti",
    },
    waitToLoadMore: {
      title: "Revisa los posts actuales primero!",
      subtitle: "Por favor, revisa los posts actuales unos segundos antes de cargar más",
    },
    addingContact: {
      title: "Añadiendo contacto",
      subtitle: "¡Tienes un nuevo contacto virtual!",
    },
    giftBox: {
      openMode: {
        hits: {
          title1: "Toca muchas veces para abrir",
          title2: "Sorpresa espera adentro!",
          title3: "Premio de azar te espera!",
        }
      },
      note: "Las cajas de regalo contienen nuevos contactos, items útiles y otros premios!",
    }
  },
  quizForm: {
    correct: "Correcto: ",
    correctCount: "Correcto: ",
    incorrectCount: "Errores: ",
    quizCompleted: "Cuestionario completado",
    quizCompletedDetail: "Has completado el cuestionario. Puedes intentarlo de nuevo para obtener mejores puntuaciones.",
    repeatQuiz: "Hacerlo de nuevo",
  },
  contacts: {
    newContactsNote: 'Obtén nuevos contactos encontrando nuevos contactos en el "Para ti"! Lee artículos y resuelve cuestionarios para descubrir nuevos 🎁 cajas de regalo!',
    contactTasks: 'Tareas:',
    startTaskChat: 'Iniciar tarea',
  },
  experienceBar: {
    gameLivesHint: 'Tus vidas de juegos',
    rankHint: 'Tu nivel de estudiante',
    xpLeftToNextLevel: 'XP falta para el siguiente nivel',
    xpGained: 'XP obtenido',
  },
  vocabularyPage: {
    vocabListTitle: 'Tu vocabulario',
    shortTitle: 'Tus palabras',
    emptyList: 'No hay vocabulario guardado todavía. Usa el botón "Guardar" en explicaciones de palabras para guardar palabras a tu lista.',
    wordGameButton: 'Cubo FLASH',
  },
  wordGame: {
    cube: {
      title: 'Flash cube',
      questionLabel: 'Pregunta',
      translationLabel: 'Cuál es la traducción de:',
      instruction: 'Arrastra para rotar el cubo para ver todas las opciones de respuesta.',
      otherDefinitions: 'Otros significados:',
      wordForIncorrectAnswer: 'Palabra incorrecta',
    },
    completeModal: {
      title: 'Juego completado!',
      effort: {
        veryLow: '¡Ups! 😭',
        low: 'Sigue practicando! 📚',
        medium: 'Buen esfuerzo! 💪',
        high: '¡Gran trabajo! 🎉',
        veryHigh: '¡Excelente! 🌟',
      }
    }
  }
};
